<template>
   
    <div> 
        <div class="crumbs" hidden="true" style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 会员管理
                </el-breadcrumb-item>
                 <el-breadcrumb-item>所有会员</el-breadcrumb-item>
            </el-breadcrumb>
        </div> 
        <div class="container" > 
            <div class="handle-box" style="overflow-y:hidden;"> 
            <span :hidden="closeSearch" > 
                <p class="btnCss">
                <el-input v-model.trim="query.id" style="width:135px" placeholder="会员ID" class="handle-input mr10"></el-input> 
                <el-input v-model.trim="query.phone" style="width:135px" placeholder="手机号" class="handle-input mr10"></el-input> 
                  
                 </p> 
                <p class="btnCss"> 
        
                <el-input v-model.trim="query.name" style="width:110px" placeholder="后台名称" class="handle-input mr10"></el-input> 
                <el-select v-model="query.isOn"  placeholder="是否实名" filterable  clearable   style="width:100px;margin-right:10px;" @clear="resetSelect" class="handle-select mr10">
                            <el-option value="" label="全部"  />   
                            <el-option value="1" label="已实名"  />  
                            <el-option value="0" label="未实名"  />   
                         </el-select>
                <!-- <el-select v-model="query.gid" style="width:135px" placeholder="代理等级" filterable  clearable @clear="resetSelect" class="handle-select mr10">
                    <el-option value="" label="全部"  /> 
                    <el-option v-for="item in select.option" :key="item.id" :label="item.gname" :value="item.id" />    
                </el-select>-->
               
                </p>  </span> 
                <p class="btnCss">
                    <el-button type="success"  icon="el-icon-search"  @click="handleSearch"> 搜 索 </el-button>
                <el-button type="warning" icon="el-icon-refresh" style="margin-right:10px;"    @click="refreshSearch"> 重 置 </el-button>
                 </p><p class="btnCss">
                <span class="closrSearchBtn" @click="changeI"  style="margin-left:30px;font-size:25px;line-height:35px;"><i :class="Ishow"></i></span>
               
 
                
                <el-button  type="primary"  class="handle-del "   @click="addBind" >新增会员</el-button>   
               <!-- <el-button  type="primary"  class="handle-del mr10"  @click="changeGrade" >变更等级</el-button>  -->
                <el-button  type="danger"  class="handle-del mr10"  @click="batchDelete" >删除会员</el-button>  
                
                <!-- <el-button  type="primary"  class="handle-del"  @click="downLink()" >一键招商</el-button> -->
                  </p>   
            </div>
            <el-table v-loading="loading"   style="margin-top:-15px;" element-loading-text="正在初始化会员数据"   :data="tableData" class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <el-table-column type="selection" width="30" align="center"></el-table-column>
                <el-table-column prop="id" width="65" v-if="mid==1 || mid==13" align="left" label="会员ID"></el-table-column>
                <el-table-column prop="phone" width="130" align="center" label="手机号"></el-table-column>   
                <el-table-column prop="loginName" min-width="110" align="left" label="会员昵称"></el-table-column> 
                 <el-table-column prop="isOn" width="80" align="center" label="是否实名">
                    <template slot-scope="scope">
                        <el-link :type="scope.row.isOn==1?'success':'info'">{{scope.row.isOn==1?'已实名':'未实名'}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="isOn" width="80" align="center" label="实名信息">
                    <template slot-scope="scope">
                        <el-link><i class="el-icon-lx-news" @click="smInfo(scope.row)" style="font-size:25px;"></i></el-link>
                    </template>
                </el-table-column>
               
                <!--<el-table-column prop="pid" width="65" v-if="mid==1 || mid==13" align="left" label="上级ID"></el-table-column>
                <el-table-column prop="channelName" width="110" align="left" label="上级代理"></el-table-column>
                <el-table-column prop="topName" width="110" align="left" label="一级代理"></el-table-column>
                 <el-table-column prop="gname" min-width="100" align="left" label="等级">
                    <template slot-scope="scope">
                        <el-link>{{scope.row.gname}}</el-link>
                    </template>
                </el-table-column> 
                <el-table-column prop="shopCode" min-width="120" align="left" label="店铺编码">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="copyLink(scope.row.shopCode)">{{scope.row.shopCode}}</el-link>
                    </template>
                </el-table-column>  -->
                
                 <el-table-column prop="memNum"  width="80" align="center"   label="藏品数量"></el-table-column>
                <el-table-column prop="orderMem"  width="80" align="center"   label="寄售藏品"></el-table-column>    
                <el-table-column prop="orderToday" width="80" align="center"   label="打卡次数"></el-table-column>  
                
                <el-table-column prop="pifa" width="79" align="center" label="寄售权限">
                    <template slot-scope="scope" > 
                         <el-tooltip :content="scope.row.pifa=='1'?'已开启':'已关闭'" placement="top">
                            <el-switch @change="handlePifa(scope.$index, scope.row)"
                                v-model="scope.row.pifa"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template>  
                </el-table-column>
                <el-table-column prop="status" width="79" align="center" label="账号状态">
                    <template slot-scope="scope" > 
                         <el-tooltip :content="scope.row.status=='1'?'正常':'已拉黑'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color="red"
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template>  
                </el-table-column> 
                <el-table-column prop="createTime" min-width="160" align="left"  label="创建时间"> </el-table-column>    
                 <el-table-column label="操作" min-width="100" align="center" fixed="right">
                    <template slot-scope="scope">  
                        <el-button  lot="reference" @click="AesIdEdit(scope.$index, scope.row)"   type="error" plain size="mini">修改手机/密码</el-button> 
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10,20, 50,100]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </div>
        <!-- 新建绑定弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增会员" :visible.sync="addVisible" :modal-append-to-body='false' center="true"  width="330px">
            <el-form ref="form1" :model="form" label-width="80px"> 
                <el-form-item label="后台名称" >
                    <el-input  type="text" placeholder="后台名称"  v-model.trim="form1.loginName"   style="width:200px;" ></el-input>
                </el-form-item> 
                <el-form-item label="手机号">
                    <el-input type="number" v-model.trim="form1.phone"  oninput ="value=value.replace(/[^\d]/g,'')" placeholder="登录账号" style="width:200px;"></el-input>
                </el-form-item>
                <el-form-item label="代理等级" >
                    <el-select v-model.trim="form1.gid" @click="getGradeSelect" placeholder="代理等级" style="width:200px;" filterable clearable @clear="resetSelect" class="handle-select mr10"> 
                        <el-option v-for="item in select.option" :key="item.id" :label="item.gname" :value="item.id" />    
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="验证码">
                    <el-input type="number"  v-model.trim="form1.code"  oninput ="value=value.replace(/[^\d]/g,'')" placeholder="验证码" style="width:100px;"></el-input>
                    <el-button  :type="sendSms.type" :disabled="sendSms.disabled" style="margin-left:10px;width:90px;" :style="sendSms.color"  @click="sendCode" >{{sendSms.content}}</el-button> 
                </el-form-item> -->
                <el-form-item label="初始密码">
                    <el-input v-model.trim="form1.loginPass"  placeholder="初始密码" style="width:200px;"></el-input>
                </el-form-item>
                 
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 变更代理弹出框 -->
        <el-dialog :close-on-click-modal="false" title="变更等级" :visible.sync="editVisible" :modal-append-to-body='false'  center="true" width="300px">
            <el-form ref="form" :model="form" label-width="69px">
                <el-form-item label="后台名称" >
                    <span>{{form.names}}</span>
                </el-form-item>
                <el-form-item label="变更为 " >
                    <el-select v-model.trim="form.gid" placeholder="代理等级" style="width:120px;" filterable clearable @clear="resetSelect" class="handle-select mr10"> 
                        <el-option v-for="item in select.option" :key="item.id" :label="item.gname" :value="item.id" />    
                    </el-select>
                </el-form-item>
                <el-input style="display:none" v-model="form.ids"></el-input> 
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="changeFalse">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>

        

        <el-dialog :close-on-click-modal="false" title="更改账号" :visible.sync="aesIdVisible" :modal-append-to-body='false' width="350px">
            <el-form ref="form" :model="form" label-width="90px"> 
                <el-form-item label="原来手机号" >
                    <span>{{form.phone}}</span>
                </el-form-item>
                <el-form-item label="修改手机号" >
                    <el-input  v-model.trim="formL.phone" style="width:160px" type="number" placeholder="请输入修改手机号" oninput ="value=value.replace(/[^\d]/g,'')"></el-input> 
                </el-form-item>
                <el-form-item label="修改密码" >
                    <el-input  v-model.trim="formL.loginPass" style="width:160px"   placeholder="修改密码"  ></el-input> 
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="aesIdVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveAesId">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="实名信息" :visible.sync="smVisible" :modal-append-to-body='false' width="350px">
            <el-form ref="form" :model="form" label-width="90px"> 
                <el-form-item label="真实姓名" >
                    <span>{{form.realName}}</span>
                </el-form-item>
                <el-form-item label="身份证号" >
                    <span>{{form.idCard}}</span>
                </el-form-item>
            </el-form> 
        </el-dialog>
        <el-dialog  :title="title"  :modal-append-to-body='false'   :visible.sync="downVisible" width="330px" top="40px"  >
            <div class='iframe-body-sty'>
                <iframe :src="downUrl"  frameborder="0" width="1000px" id="iframe-shrink" height="2050px"></iframe> 
            </div> 
        </el-dialog>
    </div>
</template>

<script>
import {fetchGradeSelect,fetchDataAll,saveForm,changeForm,updateSave,handleStatus,handlePifa,handelDelete} from '../../api/member'; 
import {sendSmsCode} from '../../api/common'; 
export default {

    data() {
        return {  
            Ishow:'el-icon-caret-bottom',
            closeSearch:'',
            theight:'550px',
            theight2:'550px',
            Timeout:'',
            mid:'',
            rid:'', 
            secret:'',
            stationId:'', 
            avatar:'',
            loginName:'',
            loading:false,
            phone:'',
            select:{ option:'',  },
            select2:{option:''},
            sendSms:{
                code:'-1', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
            }, 
            query: { 
                pageIndex: 1,
                pageSize: 10, 
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            title:"",
            downUrl:'',
            downVisible:false,
            editVisible: false,
            deleteVisible: false,
            addVisible:false,
            aesIdVisible:false,
            smVisible:false,
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            formL:{},
            form1: {  
                loginPass:'123456',
                gid:''
            },
            
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () {
        if(document.body.clientWidth<1000){
            this.closeSearch=true;
        }else{
            this.closeSearch=false; 
        };
        this.mid = localStorage.getItem('ms_mid'); 
        this.rid = localStorage.getItem('ms_rid');
        this.secret = localStorage.getItem('ms_secret');
        this.stationId = localStorage.getItem('ms_stationId');  
        this.loginName = localStorage.getItem('ms_username');  
        this.avatar = localStorage.getItem('ms_stationLogo'); 
        //查询列表
        this.getData(this.query);  
        //获取下拉框数据
        this.getGradeSelect();  
    },

    methods: { 
        smInfo(row){
            this.form = row;
            this.smVisible = true;
        },
        downLink(){
            this.title=localStorage.getItem('ms_stationName');
            var fid = localStorage.getItem('ms_fid');  
            var shopCode = localStorage.getItem('ms_shopCode');  
            this.downUrl = document.location.protocol+"//"+localStorage.getItem('ms_indexUrl')+"/hk/memberShare?st="+this.stationId+"&id="+fid+"&mid="+this.mid+"&sc="+shopCode;
            this.downVisible = true;
        },
        changeI(){  
                if(this.Ishow == 'el-icon-caret-bottom'){ 
                    this.Ishow = 'el-icon-caret-top';
                    this.closeSearch=false;
                }else{
                    this.Ishow='el-icon-caret-bottom'; 
                     this.closeSearch=true;
                }
            },  
        handleStatus(index,row){    
            row.stationId = this.stationId; 
            handleStatus(row).then(res => {
                this.loading = false;
                if(res.code=='200'){  
                    this.$message.success(res.message); 
                    this.getData();
                }else{ 
                    this.$message.error(res.message); 
                }  
            }); 
        },
        handlePifa(index,row){   
            let data = {};
            data.pifa = row.pifa;
            data.id = row.id;
            data.stationId = this.stationId; 
            handlePifa(data).then(res => {
                this.loading = false;
                if(res.code=='200'){  
                    this.$message.success(res.message); 
                    this.getData();
                }else{ 
                    this.$message.error(res.message); 
                }  
            }); 
        },
        //获取下拉框数据
        getGradeSelect(){ 
            this.select.mid = this.mid;
            this.select.stationId = this.stationId;
            fetchGradeSelect(this.select).then(res => {  
                if(res.code=='200'){ 
                    this.select.option = res.data.list; 
                    this.form1.gid = res.data.list[0].id;
                }
            });
        },
        //排序弹窗开启
        AesIdEdit(index,row){
            this.form = row; 
            this.aesIdVisible = true;
        },
        //排序保存
        saveAesId(){
            this.form.stationId = this.stationId;
            this.form.mid = this.mid;
            this.form.phone = this.formL.phone;
            this.form.loginPass = this.formL.loginPass;
            updateSave(this.form).then(res => {
                if(res.code=='200'){ 
                    this.aesIdVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{ 
                    this.$message.error(res.message); 
                } 
            });
        },
        getSummaries(param){
            const { columns, data } = param;
            const sums = [];
            this.theight = '540px'; 
            columns.forEach((column, index) => {
            if (index === 1) {//只找第一列放合计
                sums[index] = '统计';
                return;
            } 
            if(index < 6 || index == 12 ){
               sums[index] = '';
               return;
            } 
            const values = data.map(item => Number(item[column.property]));//把对应一列中的之全部取出，放到一个数组中
            if (!values.every(value => isNaN(value))) {//如果el-table-column中没有prop属性，这里的column.property是undefined，所以判断一下values数组是否为空
                sums[index] = values.reduce((prev, curr) => {
                console.log(prev, curr);
                const value = Number(curr);//将values中的每个值转换为number类型
                if (!isNaN(value)) {
                    return prev + curr;
                } else {
                    return prev;
                }
                }, 0);  
                if(index == 11){ 
                    sums[index] += '元';
                }
            } else {
                sums[index] = ''
            }
            });
            window.setTimeout(() => { 
                this.theight = this.theight2; 
            }, 500) ;
            return sums; 
        },
        // 触发搜索按钮

        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData(this.query);
        }, 
        copyLink(text){  
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);  
            //提示已复制
            this.$message.success("店铺编码复制成功"); 
           
        },
        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'isOn'); 
            this.$set(this.query, 'phone', ''); 
            this.$set(this.query, 'name', '');
            this.$set(this.query, 'gid' );   
            this.$set(this.query, 'id' );   
            this.getData(this.query);
        }, 

       

         //刷新
        refresh(){
            history.go(0); 
        },

        //查询
        getData(param){
            // 获取列表数据  
            param.secret = this.secret; 
            param.mid = this.mid;
            param.stationId = this.stationId;  
            fetchDataAll(param).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.phone = res.data.phone;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },

        //发送验证码
        sendCode(){ 
            //正则匹配手机号
            const phone = this.form1.phone;
            const reg =/^[1][3-9][0-9]{9}$/;
            if(!reg.test(phone)){
                this.$message.error("请输入正确的手机号"); 
                return;
            }  
            //发送短信按钮倒计时提示  
            var that = this;
            var times = 59;
            this.sendSms.disabled = true;
            this.sendSms.type='info';
            this.sendSms.color ="color:#333";
            var timeout = false;
            let codeInterval = window.setInterval(function() { 
                if(timeout){ return; }
                that.sendSms.content='倒计时'+times+'s';
                if((times--) <= 0){
                    that.sendSms.type='danger';
                    that.sendSms.content='发送验证码';
                    that.sendSms.disabled = false;
                    that.sendSms.color ="color:#fff";
                    window.clearInterval(codeInterval);
                } 
            }, 1000);  

            //发送短信
            this.sendSms.mid = this.mid;
            this.sendSms.stationId = this.stationId; 
            this.sendSms.loginName = this.loginName; 
            this.sendSms.phone = phone;   
            this.sendSms.code = "-1";
            sendSmsCode(this.sendSms).then(res => {
                if(res.code=='200'){ 
                    this.sendSms.code = res.data.code;
                    this.$message.success('发送成功'); 
                    this.getData(this.query);
                }else{ 
                    that.sendSms.type='danger';
                    that.sendSms.content='发送验证码';
                    that.sendSms.disabled = false;
                    that.sendSms.color ="color:#fff";
                    //处理该等级绑定的成员
                    this.$message.error(res.message); 
                    timeout=true;
                } 
            }); 
        },
        // 删除
        handDelete(index, row) {  
            this.form.gid=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){
                        this.addVisible = false;
                        this.$message.success('删除成功'); 
                        this.query.pageIndex = this.query.pageIndex-1;
                        this.getData(this.query);
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.success(res.message); 
                    } 
                });
            }) 
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val; 
        },
        batchDelete(){
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要删除的代理");
                return;
            }
            this.getGradeSelect(); 
            let ids = '';
            let names = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                ids += this.multipleSelection[i].id + ',';
                names += this.multipleSelection[i].loginName + '，';
            } 
            this.form.ids = ids.substr(0,ids.length-1);
            this.form.names = names.substr(0,names.length-1);   
            this.form.mid = this.mid;
            this.form.stationId = this.stationId;  
            this.$confirm('确定要删除代理 《 '+this.form.names+' 》 吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handelDelete(this.form).then(res => {
                    if(res.code=='200'){
                        this.deleteVisible = false;
                        this.$message.success(res.message); 
                        this.getData(this.query);
                    }else{
                        this.$message.error(res.message); 
                    }
                });
            })
        },
        //更改等级
        changeGrade() {
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要更改的代理");
                return;
            }
            this.getGradeSelect(); 
            let ids = '';
            let names = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                ids += this.multipleSelection[i].id + ',';
                names += this.multipleSelection[i].loginName + '，';
            } 
            this.form.ids = ids.substr(0,ids.length-1);
            this.form.names = names.substr(0,names.length-1);  
            this.editVisible = true;
        },
        //取消更改等级
        changeFalse(){
            this.editVisible = false; 
            //清空多选值
            this.multipleSelection = [];
            //多选框反选
            this.$refs.multipleTable.clearSelection();
        },

        // 新增代理
        addBind() {
            this.getGradeSelect(); 
            this.addVisible = true;
        },
        //保存新增
        saveForm() {  
            this.form1.mid = this.mid; 
            this.form1.stationId = this.stationId; 
            if( !this.form1.loginName ){
                this.$message.error("请填写后台名称");
                return;
            }
            
            if( !this.form1.phone  ){
                this.$message.error("请填写手机号");
                return;
            }
            if( this.form1.phone.length!=11  ){
                this.$message.error("手机号长度不正确！");
                return;
            }
            /*if( !this.form1.code){
                this.$message.error("请输入验证码");
                return;
            }
            if( this.form1.code != this.sendSms.code){
                this.$message.error("验证码不正确");
                return;
            } */
            if( !this.form1.loginPass){
                this.$message.error("请输入初始密码");
                return;
            }  
            this.addVisible = false;
            this.loading = true;
            this.form1.avatar = this.avatar; 
            saveForm(this.form1).then(res => {
                this.loading = false;
                if(res.code=='200'){
                    
                    this.$message.success(res.message); 
                    this.getData(this.query);
                }else{
                    this.$message.error(res.message); 
                } 
            });
        },
        
        // 保存更改
        saveEdit() {  
            this.form.mid = this.mid;
            this.form.stationId = this.stationId;  
            changeForm(this.form).then(res => {
                if(res.code=='200'){
                    this.editVisible = false;
                    this.$message.success(res.message); 
                    this.getData(this.query);
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData(this.query);
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData(this.query);
        }
    }
};
</script>  
<style>
    .iframe-body-sty{position: relative;overflow: hidden;height:600px;width: 1200px;}
	.iframe-body-sty>#iframe-shrink{position: absolute;transform:scale(0.29);left: -345px;top: -730px;} 
.el-dialog__body {
    padding: 10px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    overflow-x:hidden;
}
</style>
<style scoped>
.btnCss{
    height:35px;
}
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 120px;
    display: inline-block;
}

.handle-input {
    width: 180px;
    display: inline-block;
} 
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}


.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
<style>

@media screen and (min-width:999px){ 
    .mr10 {
        margin-right: 10px;
    }
    .el-message-box{
        width:350px;
        margin-top:-200px;
    }
     
}
</style>
